module.exports = __webpack_public_path__ + "static/media/2.29c23ad1.jpg";